export default __webpack_public_path__ + "/images/f67c69e870b04aad57fa1af49fc89640.png";